import type { BulkMessageStatisticDto, Message } from '@api'

import { toPlural } from '@/utils/helpers.ts'

export const generateFollowUpTableOptions = (
  message: Message & BulkMessageStatisticDto,
) => {
  return {
    title: 'PPV Follow-Up',
    rows: [
      {
        label: 'Sent To',
        value: `${message?.totalSent ?? 0} ${toPlural(message?.totalSent ?? 0, 'Fan')}`,
      },
      {
        label: 'Reads',
        value: `${message?.totalReads ?? 0} ${toPlural(message?.totalReads ?? 0, 'Fan')}`,
      },
      {
        label: 'Responses',
        value: `${message?.totalResponses ?? 0} ${toPlural(message?.totalResponses ?? 0, 'Fan')}`,
      },
      {
        label: 'PPV Bought',
        value: `${message?.totalPPVBought ?? 0}`,
      },
    ],
  }
}
